import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'
import Project from '@/services/projects/'

export default class User {
  static api = api.create(User)
  static readOnlyFields = ['id']

  constructor({
    id = null,
    username = '',
    firstName = '',
    lastName = '',
    fullName = '',
    email = '',
    phoneNumber = '',
    latitude = null,
    longitude = null,
    profilePic = null,
    isMaker = null,
    isActivator = null,
    isStaff = null,
    mVerifiedProjects = [],
    mUnverifiedProjects = [],
    followingProjects = [],
    followingProjectsRef = [],
    followingUsers = [],
    followingUsersRef = [],
    approvedProjects = [],
    approvedProjectsRef = [],
    mActivator = [],
    aAssignedMakers = [],
    description = null,
    interests = [],
    unreadNotificationCount = 0,
    bankingPhoneNumber = '',
    bankingFirstName = '',
    bankingLastName = '',
    twitter = '',
    instagram = '',
    facebook = '',
  } = {}) {
    Object.assign(this, {
      id,
      username,
      firstName,
      lastName,
      fullName,
      email,
      phoneNumber,
      latitude,
      longitude,
      profilePic,
      isMaker,
      isActivator,
      isStaff,
      mVerifiedProjects,
      mUnverifiedProjects,
      followingProjects,
      followingProjectsRef,
      followingUsers,
      followingUsersRef,
      approvedProjects,
      approvedProjectsRef,
      mActivator,
      aAssignedMakers,
      description,
      interests,
      unreadNotificationCount,
      bankingPhoneNumber,
      bankingFirstName,
      bankingLastName,
      twitter,
      instagram,
      facebook,
    })
  }

  copy() {
    return new User(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    if (data.mUnverifiedProjects) {
      data.mUnverifiedProjects = data.mUnverifiedProjects.map(Project.create)
    }
    if (data.mVerifiedProjects) {
      data.mVerifiedProjects = data.mVerifiedProjects.map(Project.create)
    }
    if (data.followingProjectsRef) {
      data.followingProjectsRef = data.followingProjectsRef.map(Project.create)
    }
    if (data.followingUsersRef) {
      data.followingUsersRef = data.followingUsersRef.map(User.create)
    }
    if (data.aAssignedMakers) {
      data.aAssignedMakers = data.aAssignedMakers.map(User.create)
    }
    return new User(data)
  }

  static fromAPI(json = {}) {
    const jsonCamel = objectToCamelCase(json)
    if (jsonCamel.mUnverifiedProjects) {
      jsonCamel.mUnverifiedProjects = jsonCamel.mUnverifiedProjects.map(Project.fromAPI)
    }
    if (jsonCamel.mVerifiedProjects) {
      jsonCamel.mVerifiedProjects = jsonCamel.mVerifiedProjects.map(Project.fromAPI)
    }
    if (jsonCamel.followingProjectsRef) {
      jsonCamel.followingProjectsRef = jsonCamel.followingProjectsRef.map(Project.fromAPI)
    }
    if (jsonCamel.followingUsersRef) {
      jsonCamel.followingUsersRef = jsonCamel.followingUsersRef.map(User.fromAPI)
    }
    if (jsonCamel.aAssignedMakers) {
      jsonCamel.aAssignedMakers = jsonCamel.aAssignedMakers.map(User.fromAPI)
    }
    return new User(jsonCamel)
  }
  /**
   *  Prep user data for the API. Can elect to include
   *  or exlude specific fields. The `User.readOnlyFields`
   *  are always excluded.
   **/
  static toAPI(user, fields = [], excludeFields = []) {
    // By default, send the whole user
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = user[field]
      })
    } else {
      data = user
    }

    excludeFields = [...User.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof User)) {
      throw Error(`${name} must be an instance of the User class.`)
    }
  }
}
